// extracted by mini-css-extract-plugin
export default {"banner":"n1BKM","logo":"pTSpV","text":"H6rYZ"};